import { deferredResourceQueryOptions } from "@/utils/deferred-resource-query";
import { orpc } from "@/utils/orpc.client";

export function getReleasePriceStatsResourceQueryOptions(releaseId: string, currency: string) {
  return deferredResourceQueryOptions(
    orpc.music.getReleasePriceStatsResource.queryOptions({
      input: { id: releaseId, currency },
    }),
  );
}
